import styled from 'styled-components';
import Link from './Link';
import Button from './Button';

export default styled(Button.withComponent(Link)).attrs({ type: undefined })``;
